module.exports = __webpack_public_path__ + "static/eizo-be2cda9a685d86bdc34b9d2d142c9469.svg";